import { create } from 'zustand';

type MessagingStore = {
  selectedMessageIds: string[];
  actions: {
    selectMessage: (id: string) => void;
    selectMessages: (ids: string[]) => void;
    unselectMessage: (id: string) => void;
    clearMessages: () => void;
  };
};

const useMessagingStore = create<MessagingStore>()((set) => ({
  selectedMessageIds: [],
  actions: {
    selectMessage: (messageId: string) =>
      set((state) => ({
        selectedMessageIds: [...state.selectedMessageIds, messageId],
      })),
    unselectMessage: (messageId: string) =>
      set((state) => ({
        selectedMessageIds: state.selectedMessageIds.filter(
          (id) => id !== messageId,
        ),
      })),
    selectMessages: (messageIds: string[]) =>
      set({ selectedMessageIds: messageIds }),
    clearMessages: () => set({ selectedMessageIds: [] }),
  },
}));

export const useSelectedMessageIds = () =>
  useMessagingStore((state) => state.selectedMessageIds);
export const useMessagingActions = () =>
  useMessagingStore((state) => state.actions);
